import ApiConnector from "@/repository/connector";

class Users {
  get = async (params) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/users/`, {
      params
    });
    result.value = response.data;
    result.error = response.detail
    return result;
  };
  getOne = async (id) => {
    const result = {
      value: null,
      error: null,
    }
    const response = await ApiConnector.connector.get(`/api/users/${id}/`);
    result.value = response.data;
    result.error = response.detail
    return result;
  };
}

export default new Users()